import { getAlpha2WithExceptions } from '@/components/Checkout/_helpers/functions/getAlpha2WithExceptions'
import type { SupportedAlpha2CountryCode } from '@/lib/utils/localization/getSupportedAlpha2CountryCodes'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  market: SupportedAlpha2CountryCode
  hydraToken: string
}

export type HydraGetStoreCreditResponse = {
  items: {
    [key: string]: number
  }[]
}

export async function HydraGetStoreCredit({ market, hydraToken }: Props) {
  const request: SendRequestType = {
    method: 'GET',
    url: `/customers/me/storecredit/${getAlpha2WithExceptions({
      alpha2: market,
    })}`,
    token: hydraToken,
  }

  return httpTools.sendRequest<HydraGetStoreCreditResponse>(request)
}
